import { apiSlice } from "../apiSlice";
import { PLANS_URL } from "../../constants";

export const planApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      createPlan: builder.mutation({
        query: (data) => ({
          url: `${PLANS_URL}/createplan`,
          method: 'POST',
          body: data,
        }),
      }),
      getPublicplans: builder.query({
        query: (id) => ({
          url: `${PLANS_URL}/teacherpublicplans/${id}`,
        }),
        providesTags: ['Plans'],
      }),
      getPublicplan: builder.query({
        query: (id) => ({
          url: `${PLANS_URL}/teacherpublicplan/${id}`,
        }),
      }),
      updatePlan: builder.mutation({
        query: (data) => ({
          url: `${PLANS_URL}/updateteacherplans`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['Plans'],
      }),
    }),
});

export const { 
  useCreatePlanMutation,
  useGetPublicplansQuery,
  useGetPublicplanQuery,
  useUpdatePlanMutation
} = planApiSlice;
    